import React, { useState } from "react"
import { Button } from "antd"
import { EditOutlined, MinusOutlined } from '@ant-design/icons';
import { CKENotepadTools } from "components/UI/CKEditor/CKEConfig"
import { actions as firestoreInteractionActions } from "views/Experiences/ExperienceShow/FirestoreInteractions/redux";
import { useDispatch, useSelector } from "react-redux";
import { CustomErrorMessage, InputArea, WordCount } from "components/UI/Segment/UIHelper";
import DefaultCKE from "components/UI/CKEditor/DefaultCKE";
import Draggable from "react-draggable";
import "./Notepad.scss";
import { studentNotesSelector } from "views/Experiences/ExperienceShow/FirestoreInteractions/selector";
import { useTranslate } from "lib/MrTranslate/MrTranslate";
import { activeAdjustedExperienceSelector } from "views/Experiences/selector";
import {allowedPasteCharactersLimit} from "lib/utils/helperMethods"

export const wordValidation = (text, rules = {}, mrIntl) => {
  console.log("mrintl ====>", mrIntl);
  const maxWords = rules.maxWord || 500
  const maxWordMessage = rules.maxWordMessage || mrIntl("Notepad.text_limit_reached")
  const validation = {
    success: false,
    messages: []
  }

  let hasRequiredError, hasLimitError
  if (rules.required && !text) {
    hasRequiredError = true
    validation.messages.push(rules)
  } else if (text && text >= maxWords) {
    hasLimitError = true
    validation.messages.push(maxWordMessage)
  }

  if (!hasRequiredError && !hasLimitError) {
    validation.success = true
  }
  return validation
}

const Notepad = () => {
  const studentNotes = useSelector(studentNotesSelector)
  const [showNotepad, setShowNotepad] = useState(false);
  const dispatch = useDispatch();
  const mrIntl = useTranslate()
  const maxWord = 500
  const activeExperience = useSelector(activeAdjustedExperienceSelector())
  const [wordCount, setWordCount] = useState({
    maxWord: maxWord,
    onUpdate: (stats) => {
      const isLimitExceeded = stats.words > maxWord
      const isCloseToLimit = !isLimitExceeded && stats.words > maxWord * .8;
      setWordCount({
        ...wordCount,
        ...stats,
        isLimitExceeded: isLimitExceeded,
        isCloseToLimit: isCloseToLimit
      })
      if (isLimitExceeded) {
      }
    }
  })

  const validationRules = {
    maxWord: maxWord,
    isLimitExceeded: wordCount.isLimitExceeded,
    // maxWordMessage: 'Word limit reached (Max 500). Your notes will not be saved!'
    maxWordMessage: mrIntl("Notepad.word_limit_reached_your_notes_will_not_be_saved")
  }
  const validation = wordValidation(wordCount.words, validationRules, mrIntl)
  const valid = validation.success
  let errorMessage = null
  let className = 'multiline-input-area'
  if (!valid) {
    className += ' show-error'
    errorMessage = validation.messages[0]
  }
  let ckeTools = {
    ...CKENotepadTools,
    wordCount: wordCount,
  }

  if (activeExperience && activeExperience.settings && (activeExperience.settings.mode === "offline" || activeExperience.settings.mode === "online_secure")) {
    ckeTools = {
      ...ckeTools,
      pasteCharactersLimit: allowedPasteCharactersLimit,
    }
  }

  const onTextChanged = (data, extra = {}) => {
    if (!wordCount.isLimitExceeded) {
      let userInfo = { student_notes: data }
      dispatch(
        firestoreInteractionActions.setUserInfo({ userInfo })
      );
    }
  }
  return (
    <div>
      {showNotepad && <Draggable handle="notepad-title" zindex={10}
        bounds={{ top: -0, left: -0, right: 0, bottom: 0 }}
      >
        <div className="draggable-notepad">
          <div className="notepad-header">
            <div className="notepad-title">{mrIntl("Notepad.notepad")}</div>
            <Button title={mrIntl("CommonText.close")} icon={<MinusOutlined />} type="text" onClick={() => setShowNotepad(!showNotepad)}></Button>
          </div>
          <InputArea className={className}>
            <DefaultCKE
              data={studentNotes}
              tools={ckeTools}
              placeholder={mrIntl("Notepad.write_your_notes")}
              onTextChanged={(data) => onTextChanged(data)}
            ></DefaultCKE>
            <CustomErrorMessage className="error-message" message={errorMessage} /><br />
            <WordCount wordCount={wordCount.words}></WordCount>
          </InputArea>
        </div>
      </Draggable>}
      <Button className="notepad-button"
        onClick={() => setShowNotepad(!showNotepad)}
      >
        <EditOutlined />
        {mrIntl("Notepad.notepad")}</Button>
    </div>
  );
};

export default Notepad;